import {pxToRem} from '../../../../utills/pxToRem'
import {fonts} from '../../../../theme/foundations/fonts'
import sizes from '../../../../theme/foundations/sizes'

const {md} = sizes.container
export const contentStyle = {
    boxSizing: 'border-box',
    color: 'black',
    fontFamily: fonts.primary,
    fontSize: pxToRem(12),

    h1: {
        fontWeight: 400,
        fontSize: pxToRem(24),
        lineHeight: pxToRem(30),
        margin: `${pxToRem(10)} 0 ${pxToRem(10)}`,
        letterSpacing: pxToRem(1),

        [`@media (min-width: ${md})`]: {
            fontSize: pxToRem(21),
            margin: `${pxToRem(14)} ${pxToRem(14)} 0`,
            lineHeight: pxToRem(18)
        }
    },

    h2: {
        fontSize: pxToRem(28),
        lineHeight: pxToRem(30),
        margin: `${pxToRem(24)} 0`,
        letterSpacing: pxToRem(1),

        [`@media (min-width: ${md})`]: {
            fontSize: pxToRem(16),
            margin: `${pxToRem(13)} 0`,
            letterSpacing: pxToRem(1)
        }
    },

    h3: {
        fontSize: pxToRem(14),
        letterSpacing: pxToRem(1),
        marginBlock: pxToRem(14),
        lineHeight: pxToRem(18)
    },

    p: {
        fontSize: pxToRem(12),
        letterSpacing: pxToRem(1),
        marginBlock: pxToRem(12)
    },

    hr: {
        marginBlock: pxToRem(6),
        border: `${pxToRem(1)} solid`
    },

    a: {
        color: 'black',

        '&:hover': {
            color: 'cav_dark_red'
        }
    }
}
